import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eye, EyeOff, Key, Trash2 } from 'lucide-react';
export function ApiSettings({ apiKeys, showPasswords, onGenerateApiKey, onToggleApiKey, onDeleteApiKey, onToggleShowPasswords }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "space-y-6",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between mb-4",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "text-lg font-medium text-foreground",
                            children: "API Keys"
                        }),
                        /*#__PURE__*/ _jsxs("button", {
                            onClick: onGenerateApiKey,
                            className: "inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-primary-foreground bg-primary hover:bg-primary/90",
                            children: [
                                /*#__PURE__*/ _jsx(Key, {
                                    className: "w-4 h-4 mr-2"
                                }),
                                "Generate New Key"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-4",
                    children: apiKeys.map((apiKey)=>/*#__PURE__*/ _jsxs("div", {
                            className: "border border-border rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-between mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("h4", {
                                                    className: "font-medium text-foreground",
                                                    children: apiKey.name
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: [
                                                        "Last used: ",
                                                        new Date(apiKey.lastUsed).toLocaleDateString()
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: `inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${apiKey.active ? 'bg-success-muted text-success' : 'bg-muted text-foreground'}`,
                                                    children: apiKey.active ? 'Active' : 'Inactive'
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    onClick: ()=>onToggleApiKey(apiKey.id),
                                                    className: "p-1 text-muted-foreground hover:text-muted-foreground",
                                                    children: apiKey.active ? /*#__PURE__*/ _jsx(Eye, {
                                                        className: "w-4 h-4"
                                                    }) : /*#__PURE__*/ _jsx(EyeOff, {
                                                        className: "w-4 h-4"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    onClick: ()=>onDeleteApiKey(apiKey.id),
                                                    className: "p-1 text-danger hover:text-danger",
                                                    children: /*#__PURE__*/ _jsx(Trash2, {
                                                        className: "w-4 h-4"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("code", {
                                            className: "flex-1 bg-muted px-3 py-2 rounded text-sm font-mono",
                                            children: showPasswords ? apiKey.key : '••••••••••••••••••••'
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            onClick: onToggleShowPasswords,
                                            className: "p-2 text-muted-foreground hover:text-muted-foreground",
                                            children: showPasswords ? /*#__PURE__*/ _jsx(EyeOff, {
                                                className: "w-4 h-4"
                                            }) : /*#__PURE__*/ _jsx(Eye, {
                                                className: "w-4 h-4"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mt-2 flex flex-wrap gap-1",
                                    children: apiKey.permissions.map((permission)=>/*#__PURE__*/ _jsx("span", {
                                            className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-info-muted text-info",
                                            children: permission
                                        }, permission))
                                })
                            ]
                        }, apiKey.id))
                })
            ]
        })
    });
}
